module.exports = __webpack_public_path__ + "img/532m3.8eaa516a.jpg";